import React, { useEffect, useContext, isValidElement, cloneElement } from 'react';
import { useSpring, animated } from 'react-spring';
import { useDrag } from 'react-use-gesture';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GlobalStateContext } from '../context/globalStateProvider';

const BottomSheet = ({ isOpen, children }) => {
    const theme = useTheme();
    const {position} = useContext(GlobalStateContext)
    const initialPosition = position ? position + 24 : window.innerHeight * 0.40;
    const [{ y }, api] = useSpring(() => ({ y: initialPosition }));
    
    const openSheet = () => api.start({ y: 0 });
    const closeSheet = () => api.start({ y: initialPosition });
    const bind = useDrag(
        ({ last, velocity, direction: [, dy], movement: [, my], cancel }) => {
            if (my < -70) cancel();
            if (last) {
                if (my > window.innerHeight * 0.25 || (velocity > 0.5 && dy > 0)) closeSheet();
                else openSheet();

            } else api.start({ y: my, immediate: true });
        },
        { from: () => [0, y.get()], bounds: { top: 0 }, rubberband: true }
    );

     const modifiedChildren = React.Children.map(children, (child) => {
        if (isValidElement(child) && child.props.draggable) {
            return cloneElement(child, { bindDrag: bind });
        }
        return child;
    });

    useEffect(() => {
        if (isOpen) api.start({ y: initialPosition });
        else api.start({ y: window.innerHeight });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, api]); 

    return (
        <>
            <Box ></Box>
            <animated.div className="bottom-sheet" style={{ transform: y.to((y) => `translateY(${y}px)`) }}>
                <Box sx={{width:"100%", padding:"16px 0px 16px 0px", display:"flex", justifyContent:"center", alignItems:"center"}} {...bind()}>
                <Box sx={theme.customStyles.dragHandle}></Box>
                </Box>
                <Box sx={theme.customStyles.bottomSheetContent}>
                    {modifiedChildren}
                </Box>
            </animated.div>
        </>
    );
};

export default BottomSheet;
